import { format } from "date-fns";
import { chargeBreakdown } from "utils/gstCalc";

export const chargeSummary = ({
  primaryCharge,
  serviceCharge,
  extraCharges,
  primaryChargeGst,
  serviceChargeGst,
  extraChargesGst,
  discount,
} = {}) =>
  chargeBreakdown(
    { primaryCharge, serviceCharge, extraCharges },
    { primaryChargeGst, serviceChargeGst, extraChargesGst },
    discount
  );

export const isRefund = (payment) => payment?.entryType === "REFUND";

export const signedAmount = (payment) =>
  (isRefund(payment) ? -1 : 1) * (Number(payment?.amount) || 0);

export const totalVerifiedPaid = (payments = []) =>
  payments
    .filter((payment) => payment.status === "VERIFIED")
    .reduce((sum, payment) => sum + signedAmount(payment), 0);

/** What a new refund may still take: net verified money less refunds already awaiting verification. */
export const refundableAvailable = (payments = []) => {
  const pendingRefunds = payments
    .filter((payment) => payment.status === "PENDING_VERIFICATION" && isRefund(payment))
    .reduce((sum, payment) => sum + (Number(payment.amount) || 0), 0);
  return Math.max(0, totalVerifiedPaid(payments) - pendingRefunds);
};

export const balanceDue = (finalAmount, totalPaid) =>
  Math.max((Number(finalAmount) || 0) - totalPaid, 0);

export const createEmptyDraft = () => ({
  amount: "",
  date: format(new Date(), "yyyy-MM-dd"),
  reference: "",
  notes: "",
  method: "",
  autoVerify: false,
});

export const validatePaymentDraft = (draft, { requireMethod = false } = {}) => {
  const amount = Number(draft.amount);
  if (!amount || amount <= 0) return "Enter a valid payment amount";
  if (!draft.date) return "Select the payment date";
  if (requireMethod && !draft.method) return "Select a payment method";
  return null;
};

export const toPaymentPayload = (draft, attachments = []) => ({
  amount: draft.amount,
  date: draft.date,
  reference: draft.reference?.trim() || null,
  notes: draft.notes?.trim() || null,
  method: draft.method || null,
  receiptDocuments: attachments.filter(Boolean),
  autoVerify: draft.autoVerify,
});
